import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editRecommendationCommentDialog from '../dialog.editRecommendationCommentDialog';
import controller from './recommendation-comment.controller';
import directive from './recommendation-comment.directive';


export default angular.module('app.components.advisory.auditTrail.recommendationComment', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  editRecommendationCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amRecommendationComment', directive)
  .controller('RecommendationCommentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.recommendationComment created');
